import moment from "moment";

export default function getDateTime(dateTime) {
    if (!dateTime) {
        return '---'
    }

    const date = new Date(dateTime)
    const today = new Date()

    if (date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear()) {
        return moment(dateTime).format('LT')
    }

    if (date.getFullYear() !== today.getFullYear()) {
        return moment(dateTime).format('DD/MM/YY')
    }

    return moment(dateTime).format('MMM D')
}